'use client';
import React, { useEffect, useState } from 'react';

export default function MobileStickyBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 sm:hidden sticky-bar px-4 py-3 safe-area-inset-bottom">
      <div className="flex items-center gap-3">
        {/* App Store */}
        <a
          href="#"
          className="btn-primary flex-1 flex items-center justify-center gap-2 py-3 rounded-xl text-slate-deep font-bold text-sm"
          aria-label="Download on App Store"
        >
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
            <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
          </svg>
          App Store
        </a>
        {/* Google Play */}
        <a
          href="#"
          className="glass-card flex-1 flex items-center justify-center gap-2 py-3 rounded-xl text-frost font-bold text-sm border border-sky-DEFAULT/20"
          aria-label="Get it on Google Play"
        >
          <svg className="w-4 h-4 text-sky-DEFAULT" fill="currentColor" viewBox="0 0 24 24">
            <path d="M3.18 23.76c.37.2.8.22 1.2.06l12.6-7.27-2.74-2.74-11.06 9.95zM20.66 9.65L17.5 7.8 14.4 10.9l3.1 3.1 3.16-1.83c.9-.52.9-1.99 0-2.52zM2.04.28C1.74.53 1.5.92 1.5 1.42v21.16c0 .5.24.89.54 1.14L13.47 12 2.04.28zM4.38.18L16.98 7.45l-2.74 2.74L4.38.18z"/>
          </svg>
          Google Play
        </a>
        {/* Dismiss */}
        <button
          onClick={() => setVisible(false)}
          className="text-chrome-dim p-2"
          aria-label="Dismiss"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>
    </div>
  );
}